import { State } from "reducers";

export const inAJourney = ({
  app: { fullscreenMode },
  switcher: { onNow },
}: State) => !!onNow && fullscreenMode;

export const inJourneyTopLevel = (state: State) =>
  inAJourney(state) && state.switcher.onNow.pageIndex === 0;
